/** Trades (V3Trades): every fill across all bots, filter by bot, CSV export. */
import { useState } from "react";
import { Shell } from "../components/Shell.tsx";
import { Page } from "../components/ui.tsx";
import { useApi } from "../lib/data.ts";
import type { Bot, Fill } from "../lib/types.ts";
import { FillTable } from "./Bot.tsx";

export function Trades() {
  const [bot, setBot] = useState(""), [cursors, setCursors] = useState<number[]>([]);
  const before = cursors[cursors.length - 1];
  const { data: bots } = useApi<{ accounts: Bot[] }>("/accounts");
  const { data, loading } = useApi<{ fills: Fill[] }>(`/trades?limit=200${bot ? `&bot=${bot}` : ""}${before ? `&before=${before}` : ""}`);
  const csv = () => {
    const rows = [["time_utc", "bot", "symbol", "market", "book", "side", "qty", "price", "notional", "fee", "position_after", "reason"],
      ...(data?.fills ?? []).map((f) => [new Date(f.ts).toISOString(), f.bot_name ?? "", f.symbol, f.market, f.book, f.side, f.qty, f.price, f.notional, f.fee, f.position_after, f.reason])];
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([rows.map((r) => r.join(",")).join("\n")], { type: "text/csv" }));
    a.download = `dukun-trades-${new Date().toISOString().slice(0, 10)}.csv`; a.click();
  };
  return (
    <Shell crumb="Views · Trades" actions={<button className="btn" onClick={csv} disabled={!data?.fills.length}>Download CSV</button>}>
      <Page eyebrow="Views" title="Trades" width={1100}>
        <label className="flex items-center gap-2 text-[13px] text-muted">Bot
          <select className="input w-auto py-1.5" value={bot} onChange={(e) => { setBot(e.target.value); setCursors([]); }}><option value="">All bots</option>{bots?.accounts.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}</select></label>
        <FillTable fills={data?.fills ?? []} loading={loading} showBot />
        <div className="flex gap-2">
          {cursors.length > 0 && <button className="btn" onClick={() => setCursors(cursors.slice(0, -1))}>Newer</button>}
          {(data?.fills.length ?? 0) === 200 && <button className="btn" onClick={() => setCursors([...cursors, data!.fills[data!.fills.length - 1]!.ts])}>Older</button>}
        </div>
      </Page>
    </Shell>
  );
}
